const openApp = (urlScheme) => {
  const tempElement = document.createElement('a');
  tempElement.href = urlScheme;
  tempElement.click();
  tempElement.remove();
};
const openExternal = (url) => {
  openApp(`socar-v2://open-url/external?url=${encodeURIComponent(url)}`);
};
const openInternal = (url) => {
  openApp(`socar-v2://open-url/internal?url=${encodeURIComponent(url)}`);
};
export default {
  openExternal,
  openInternal,
};
